'use client';

import styles from './ReferencesCards.module.scss';
import Text from '@/components/Text/Text';
import Card, { ICard } from '@/components/Card/Card';

export interface IReferencesCards {
  __component: 'ingredient.references';
  id: number;
  label: string;
  title: string;
  referencesList: ICard[];
}

const ReferencesCards = ({ data }: { data: IReferencesCards }) => (
  <section className={styles.referencesCards}>
    <div className={styles.left}>
      <p className={styles.tagline}>{data.label}</p>
      <div className={styles.textContent}>
        <Text tag='h2'>{data.title}</Text>
      </div>
    </div>

    <div className={styles.right}>
      {data.referencesList.map((card) => (
        <Card
          key={card.id}
          card={card}
        />
      ))}
    </div>
  </section>
);

export default ReferencesCards;
